import { render } from "./tmsAccount.vue?vue&type=template&id=2536f388&scoped=true"
import script from "./tmsAccount.vue?vue&type=script&lang=js"
export * from "./tmsAccount.vue?vue&type=script&lang=js"

import "./tmsAccount.vue?vue&type=style&index=0&id=2536f388&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2536f388"]])

export default __exports__